module.exports = __webpack_public_path__ + "img/photoAlbum2.745f6bc6.jpg";